import React from 'react';
import { Container, Button } from 'react-bootstrap';
import ScenarioIcon from './ScenarioIcon';
import { ICON_BG } from '../scenarioConfig';
import LoadingButton from '../../../components/LoadingButton';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const ScenarioLayout = ({
  mode,
  name,
  title,
  subtitle,
  icon,
  children,
  onGenerate,
  onSave,
  disableSave,
  color,
  isLoading,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const isCanBack = useSelector((state) => state.users.historyStack.length > 1);
  const goBack = () => isCanBack ? history.goBack() : history.push('/model-scenarios');

  const renderActionBtn = () => {
    if (mode === 'view') {
      return null;
    }
    return (
      <div>
        <LoadingButton isLoading={isLoading} />
        <Button
          variant="outline-secondary"
          className="mr-2"
          onClick={onSave}
          disabled={disableSave || isLoading}
        >
          {t('Save')}
        </Button>

        <Button variant="dark" onClick={onGenerate} disabled={isLoading}>
          {t('Generate Outputs')}
        </Button>
      </div>
    )
  }

  return (
    <Container fluid className="pt-4 px-4 pb-4">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div className="d-flex align-items-center">
          <Button variant="link" className="p-0 mr-3" onClick={goBack} style={{ fontWeight: 700, fontSize: '1.1em' }}>
            {t('← Back')}
          </Button>

          <div className="d-flex align-items-center">
            <div
              className="mr-3 d-flex align-items-center justify-content-center rounded-6"
              style={{
                width: 40,
                height: 40,
                backgroundColor: ICON_BG[color],
              }}
            >
              <ScenarioIcon
                type={icon}
                className={`text-${color}`}
                style={{ width: 20, height: 20 }}
              />
            </div>
            <div>
              <div className="font-weight-bold">{title}{name ? `: ${name}` : ''}</div>
              <div className="text-muted small">{subtitle}</div>
            </div>
          </div>
        </div>
        {renderActionBtn()}
      </div>

      {children}
    </Container>
  );
};

export default ScenarioLayout;
